import { Navigate, useParams } from 'react-router-dom';

import { nfcCardPath } from 'lib/nfcCardScreens';

/**
 * The old route of a card, which showed balance, movements and loads in one screen. A link
 * to it opens the loads, which is what it was first made for.
 */
export default function NfcCardRedirect() {
	const { cardId = '' } = useParams<{ cardId: string }>();

	return <Navigate to={nfcCardPath(cardId, 'cargas')} replace />;
}
